<template lang="html">
  <div v-scroll="onScroll">
    <v-container fluid class="pa-0">
      <!-- table header  -->
      <div class="task__table-head" v-if="list">
        <v-layout row wrap class="pb-3">
          <v-flex sm6>
            <v-layout row wrap>
              <v-btn flat icon @click="toggleFilter= !toggleFilter"><i class="filter-icon pr-2"></i></v-btn>
              <v-btn flat icon @click="toggleSearchTask=!toggleSearchTask"><i class="search-icon pr-4"></i></v-btn>
              <input v-if="toggleSearchTask" type="text" placeholder="search" v-model="searchTaskValue" @keyup="searchTasks(searchTaskValue)" class="search-input pl-2">
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- browse tasks filter -->
        <div v-if="toggleFilter" class="filter-view">
          <v-container grid-list-md class="ma-0">
            <v-layout row wrap>
              <v-flex xs12 sm4 class="pr-4">
                <v-layout row wrap class="input-container">
                  <v-flex xs12 sm5 lg2 class="pt-3">
                    <label for="project">Project</label>
                  </v-flex>
                  <v-flex xs12 sm7 lg10>
                    <v-select
                      solo
                      class="select"
                      placeholder="Project"
                      item-text="project_name"
                      item-value="project_id"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4>
                <v-layout column wrap class="pt-4 pb-4">
                  <h5>Project type</h5>
                  <v-layout row wrap>
                    <v-flex xs6 sm6>
                      <v-checkbox
                        label="Local"
                        color= 'blue'
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs6 sm6>
                      <v-checkbox
                        label="Virtual"
                        color= 'blue'
                      >
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4>
                <v-layout column wrap class="pt-4 pb-4">
                  <h5>Days left</h5>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-checkbox
                        label="< 1"
                        color='blue'
                        value="<1"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        label="1-3"
                        color='blue'
                        value="1-3"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox
                        label="3+"
                        color='blue'
                        value="3+"
                      >
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout column wrap>
              <v-flex xs10>
                <v-layout column wrap class="pt-4 pb-4">
                  <h5>Distance from me</h5>
                  <v-layout row wrap>
                    <v-flex xs12 sm2>
                      <v-checkbox
                        label="< 1 km"
                        color='blue'
                        value="< 1 km"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-checkbox
                        label="1-5 km"
                        color='blue'
                        value="1-5 km"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-checkbox
                        label="5-10 km"
                        color='blue'
                        value="5-10 km"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-checkbox
                        label="10-30 km"
                        color='blue'
                        value="10-30 km"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-checkbox
                        label="30+ km"
                        color='blue'
                        value="30+ km"
                      >
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>

      <div v-if="noData && !loading" class="loader-container">
        <no-data-message>
          <v-icon slot="icon">event_note</v-icon>
          <div slot="message">
            There are no effort items to show
          </div>
          <div slot="sub-message">
            You can explore new effort from the button below
          </div>
          <div slot="button">
            <router-link :to="{name: 'Tasks', query: { browse_id: 1 }}">
              Find Effort
            </router-link>
          </div>
        </no-data-message>
      </div>

      <div v-else-if="engage" class="task-card__container">
        <template v-if="activeTaskId">
          <v-btn color="error" fab large dark class="task-browse__navigation--large" @click="onPrev" :disabled="disablePrev">
            <v-icon>skip_previous</v-icon>
          </v-btn>
          <task-card :task_id="activeTaskId" v-if="activeTaskId">
            <button class="task__button task-browse__navigation--small" @click="onPrev" :disabled="disablePrev">
              Prev
            </button>

            <v-btn-toggle>
              <v-btn icon :to="{name: 'TaskDetails', params: {id: activeTaskId}}">
                See Details
              </v-btn>
              <v-btn icon title="follow this effort" @click="followTask(activeTaskId)">
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </v-btn-toggle>

            <button class="task__button task-browse__navigation--small" @click="onNext" :disabled="disableNext">
              Next
            </button>
          </task-card>
          <v-btn color="error" fab large dark class="task-browse__navigation--large" @click="onNext" :disabled="disableNext">
            <v-icon>skip_next</v-icon>
          </v-btn>
        </template>
      </div>

      <div v-else-if="list" class="task-view" v-for="(task, i) in tasks">
        <div>
          <v-layout row wrap align-end class="list-elements">
            <v-flex sm6 xs12 class="">
              <router-link class="project-name caption" :to="{name: 'ProjectOverview', params: {id: task.project_id}}">
                {{ task.project_name }}
              </router-link>
              <div class="task-name" @click="navigateToTaskDetails(task.task_id)">
                {{ task.task_name || task.task_ref || `E${task.task_id}` }}
              </div>
            </v-flex>
            <!-- <v-flex sm4>
              <span></span>
            </v-flex> -->
            <v-flex sm5 xs12 class="task__metrics">
              <span>
                <span class=" sub-headers">{{ timeToStart(task) }}</span>
                <v-icon title="Time to Start" class="icon--grey small-icon">timelapse</v-icon>
              </span>
              <span v-if="task.task_duration">
                <span class=" sub-headers">{{ duration(task) }}</span>
                <v-icon title="Duration" class="clock-grey-icon small-icon"></v-icon>
              </span>
              <span v-if="false">
                <span class=" sub-headers">{{ '-' }}</span>
                <v-icon title="Completed Tasks" class="completions-grey-icon small-icon"></v-icon>
              </span>
            </v-flex>

            <v-flex sm1 xs12 class="task__actions">
              <v-tooltip top>
                <v-btn slot="activator" icon class="action-icons" @click="followTask(task.task_id)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <span>Follow</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div v-if="loading" class="loader-container">
        <loader></loader>
      </div>

      <!-- fixed button for browse tasks -->
    </v-container>
    <div class="action-button" v-show="showFindEffortButton && list">
      <v-btn large class="fixed-primary-button white--text" :to="{name: 'Tasks', query: { browse_id: 1 }}">
        Find Effort
      </v-btn>
    </div>
  </div>
</template>


<script>
import moment from 'moment';
import get from 'lodash/get';

import { getTaskList } from '@/api';

import TaskCard from '@/components/shared/TaskCard';

export default {
  components: { TaskCard },
  data() {
    return {
      activeTask: 0,
      toggleFilter: false,
      toggleSearchTask: false,
      showFindEffortButton: false,

      lastScroll: 0,
      loading: false,
      tasks: [],
      take: 20,
      skip: 0,
      exhausted: false,
    };
  },
  computed: {
    style() {
      return this.$route.query.style || 'engage';
    },
    engage() {
      return this.style === 'engage';
    },
    list() {
      return this.style === 'list';
    },
    disablePrev() {
      return this.activeTask === 0;
    },
    disableNext() {
      return this.activeTask + 1 === this.tasks.length;
    },
    activeTaskId() {
      return get(this.tasks, `[${this.activeTask}].task_id`);
    },
    noData() {
      return this.tasks.length === 0;
    },
    browseId() {
      return this.$route.query.browse_id;
    },
  },
  methods: {
    onNext() {
      this.activeTask = Math.min(this.activeTask + 1, this.tasks.length - 1);
      // this.$route.params.active = this.activeTask;
      this.$router.replace({
        name: 'Tasks',
        query: {
          ...this.$route.query,
          active: this.activeTask,
        },
      });
    },
    onPrev() {
      this.activeTask = Math.max(this.activeTask - 1, 0);
      // this.$route.params.active = this.activeTask;
      this.$router.replace({
        name: 'Tasks',
        query: {
          ...this.$route.query,
          active: this.activeTask,
        },
      });
    },
    followTask(taskId) {
      this.$store.dispatch('tasks/followTask', taskId);
    },
    timeToStart(task) {
      if (!task.task_date) return 'ongoing';
      return moment(task.task_date).fromNow();
    },
    duration(task) {
      if (!task.task_duration) return '-';
      const minutes = parseInt(task.task_duration, 10);
      return moment().add(minutes, 'minutes').fromNow(true);
    },
    navigateToTaskDetails(taskId) {
      this.$router.push({ name: 'TaskDetails', params: { id: taskId } });
    },
    onScroll() {
      const scroll = this.$scrollPercent();
      const scrollingUp = this.lastScroll > scroll;
      this.lastScroll = scroll;
      this.showFindEffortButton = scroll > 0.2;

      if (scroll < 0.90 || scrollingUp) return null;

      this.fetchTasks();
      return null;
    },
    fetchTasks: async function fetchTasks() {
      if (this.exhausted || this.loading) return;

      const browseId = this.$route.query.browse_id;
      const userToken = this.$store.getters['auth/userToken'];

      const formData = {
        browse_id: browseId,
        skip: this.skip,
        take: this.take,
      };

      this.loading = true;
      const { data } = await getTaskList(userToken, formData);

      if (get(data, '[1].error.error_type') === 'NO_DATA') {
        this.exhausted = true;
      }

      const tasks = get(data, '[1].data.details', []);
      this.tasks = [...this.tasks, ...tasks];
      this.skip += this.take;
      this.loading = false;
    },
  },
  watch: {
    browseId: {
      immediate: true,
      handler(id) {
        if (!id) return;

        this.tasks = [];
        this.loading = false;
        this.exhausted = false;
        this.skip = 0;
        this.fetchTasks();
      },
    },
  },
  mounted() {
    this.fetchTasks();
    // handle active task id from the query
    const active = this.$route.query.active || 0;
    this.activeTask = active;
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
    a {
      text-decoration: none;
    }

    .task__table-head {
      border-bottom: 1px solid #e5e5e5;
    }

    .sub-headers {
      font-size: 12px;
      color: $placeholder;
    }

    .follow-button {
      color: $blue;
    }

    .follow-button .btn__content span {
      font-size: 13px !important;
    }

    .filter-view {
      padding: 16px;
      margin-bottom:12px;
      background: $filter-background;
    }

    .search-input:focus {
      outline: none;
      border-bottom: 1px solid $blue;
      width: 80%;
      font-size: 16px;
    }

    .task-name {
      font-size: 16px;
      color: $blue;
      cursor: pointer;
    }

    .list__tile__content {
      color: $blue;
      font-size: 16px;
    }

    .action-button {
      position: fixed;
      bottom: 5px;
      min-width: 100px;
      left: calc(50% - 70px);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5;
      margin-bottom: 20px;
    }


    @media only screen and (max-width:600px) {
      .action-button {
        margin-bottom: 70px;
      }
    }

    @media only screen and (min-width:1600px) {
      .action-button {
        left: calc(50vw + 100px);
      }
    }

    .fixed-primary-button {
      background: $primary;
      font-family: MuseoSans-900;
      text-align: center;
      border-radius: 24px;
      padding: 1px;
    }

    .centered {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 80%;
    }

    .icon--grey {
      color: #bbc2c8;
    }

    .task-view:nth-child(odd) {
      background: $filter-background;
    }

    .list-elements {
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 16px;
      line-height: 2;
      padding-right: 16px;
      .btn {
        min-width: auto;
      }
    }

    .project-name {
      color: $light;
    }

    .task__metrics > span {
      display: inline-block;
      color: $placeholder;
      font-size: 12px;
    }

    .task__metrics > span::after {
      content: '\00B7';
      color: $placeholder;
      font-weight: bold;
      margin: 0 10px;
    }

    .task__metrics > span:last-child::after {
      display: none;
    }

    .loader-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 80%;
    }

    .action-icons.btn.btn--icon {
      color: #7e7e7e;
    }

    .task__actions {
      display: flex;
      justify-content: end;
    }

    .half-circle-spinner {
      width: 30px;
      height: 30px;
    }

    .task-card__container {
      display: flex;
      justify-content: space-between;
      padding-bottom: 15px;
      height: 100%;
    }

    .task-browse__navigation--small {
      display: none;
    }

    .task-browse__navigation--large {
      display: inherit;
      margin: 50px;
      margin-top: 200px;
    }

    @media only screen and (max-width: 900px) {
      .task-card__container {
        justify-content: center;
      }

      .task-browse__navigation--small {
        display: inherit;
      }

      .task-browse__navigation--large {
        display: none;
      }
    }

    .btn-toggle {
      background: $primary !important;
      border-radius: 24px 24px 24px 24px;
      background-color: white;
      box-shadow: none;
      width: 155px !important;
      margin-bottom: 0 !important;
      height: 40px !important;
      padding-left: 5px;
      padding-right: 5px;

      .btn {
        width: auto;
        border: none;
        color: white !important;
      }

      .btn:first-child {
        border-top-left-radius: 23px;
        border-bottom-left-radius: 23px;
        border-right: 1px solid #d64054;
        padding-right: 15px;
      }

      .btn:last-child {
        box-shadow: none;
        border-top-right-radius: 23px;
        border-bottom-right-radius: 23px;
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/TaskBrowse.vue